var ReactDirtyRouteMixin = require('../mixins/react-dirty-route')
var getUserType = require('../utils/get-user-type')

module.exports = Em.ObjectController.extend(ReactDirtyRouteMixin, {
    needs: ['application', 'user'],

    organization: Em.computed.alias('controllers.user.activeOrganization'),

    activeUmbrella: Em.computed.alias('sideMenu.activeUmbrella'),

    activeMembership: Em.computed.oneWay('userOrganizations.activeMembership'),

    userType: function() {
        return getUserType(this.get('activeMembership'))
    }.property('activeMembership')
})
